import React from 'react';
import Masonry from 'react-masonry-css';
import Prompt from './Prompt';

const breakpointObj = {
    default: 4,
    3000: 6,
    2000: 5,
    1200: 3,
    1000: 2,
    500: 1,
}

const MasonryLayout = ({ prompts }) => {
  return (
    <Masonry className='flex animate-slide-fwd' breakpointCols={breakpointObj}>
        {prompts?.map((prompt) => <Prompt key={prompt._id} prompt={prompt} className='w-max' />)}
    </Masonry>
  )
}

export default MasonryLayout